import type { UseFetchOptions } from '#app'

// 防止多个请求同时触发多次跳转
let isRedirecting = false

function handleAuthError(res: any) {
  if (process.server || isRedirecting) return
  // 兼容 string 和 object 两种响应
  let data = res
  if (typeof data === 'string') {
    try { data = JSON.parse(data) } catch { return }
  }
  const code = data?.code
  // 2002: 未登录  3002: uuid 缺失
  if (code === 2002 || code === 3002) {
    isRedirecting = true
    const currentPath = window.location.pathname + window.location.search
    window.location.replace(`/init-visitor?return_to=${encodeURIComponent(currentPath)}`)
  }
}

// 普通的 $fetch 封装
export async function clientFetch(path: string, options: any = {}) {
  const res = (await $fetch(path, {
    headers: useRequestHeaders(['cookie']),
    ...options
  })) as any
  handleAuthError(res)
  return res
}

// 专门处理缓存和响应式请求数据的 useFetch 封装
export async function useClientFetch<T>(
  path: string,
  options: UseFetchOptions<T> = {}
) {
  return useFetch(path, {
    credentials: 'include',
    ...options,
    onResponse({ response }) {
      handleAuthError(response._data)
    }
  }) as any
}
